import React from 'react';

import BlockAccessPage from '../../../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../../../components/Menu/Utils/commonFunctions';
import FuelTable from '../../../../../components/Table/FuelTable';
import FugitiveEmission from '../../../../../components/Table/FugitiveEmissionsTable';
import MobileFuelTable from '../../../../../components/Table/MobileFuelTable';
import Tabs from '../../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../../constants/permissionsEnum';
import TranslatedText from '../../../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';

const FuelConsumptions: React.FC<{
  selectedYear: string;
  facilityId: string;
}> = ({facilityId, selectedYear}) => {
  const FCTab = [
    {
      id: 'fuelConsumption',
      name: <TranslatedText translationKey="By Machine" />,
      component: shouldBlockModuleAccess(accessModule.scope1) ? (
        <BlockAccessPage />
      ) : (
        <FuelTable facilityId={facilityId} selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerFuelByMachine)
    },
    {
      id: 'infraProfile',
      name: <TranslatedText translationKey="By Vehicle" />,
      component: shouldBlockModuleAccess(accessModule.scope1) ? (
        <BlockAccessPage />
      ) : (
        <MobileFuelTable facilityId={facilityId} selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerFuelByVehicle)
    },
    {
      id: 'refri',
      name: <TranslatedText translationKey="By Refrigerant/Suppressant" />,
      component: shouldBlockModuleAccess(accessModule.scope1) ? (
        <BlockAccessPage />
      ) : (
        <FugitiveEmission facilityId={facilityId} selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerFuelByRefrigerantSuppressant
      )
    }
  ].filter((item) => !item.hidden);

  return <Tabs array={FCTab} type="card" />;
};

export default FuelConsumptions;
